module.exports = __webpack_public_path__ + "img/title_bg_child.404519ec.png";